<template>
    <div class="ecm-article-map">

        <l-map
            ref="articleMap"
            :zoom="15"
            :center="mapCenter"
            :options="mapOptions">

            <l-tile-layer
                :url="url"
                :errorTileUrl="errorTileUrl"
                :attribution="attribution" />

            <l-marker v-if="latitude && longitude" :lat-lng="[latitude, longitude]" ></l-marker>

            <div v-if="waypoints">
                <l-polyline 
                    v-for="(segment, index) in waypoints" 
                    :key="'polyline-'+index" 
                    :lat-lngs="segment" 
                    :color="config.polylineOptions.strokeColor"
                    :weight="config.polylineOptions.strokeWeight">
                </l-polyline>
            </div>

        </l-map>

    </div>
</template>

<script>
import { store } from '../store/store';
import L from 'leaflet';
import { LMap, LMarker, LPolyline, LTileLayer } from 'vue2-leaflet';

export default {
    name: 'ArticleMap',
    components: {
        LMap,
        LMarker,
        LPolyline,
        LTileLayer
    },
    props: {
        latitude: [String, Number],
        longitude: [String, Number],
        waypoints: Array
    },
    computed: {
        config() {
            return store.state.config;
        },
        mapCenter() {
            if (this.latitude && this.longitude) {
                // Lat and lng set, it's a place
                return [this.latitude, this.longitude];
            } else {
                // No lat and lng, it's a route
                return [this.waypoints[0][0].lat, this.waypoints[0][0].lng];
            }
        }
    },
    data() {
        return {
            map: null,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            errorTileUrl: null,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
            mapOptions: {
                zoomControl: false,
                zoomSnap: 1,
                minZoom: 1,
                maxZoom: 18,
                maxBoundsViscosity: 1.0,
                preferCanvas: true
            }
        };
    },
    mounted() {
        // Get ref to map on nextTick 
        this.$nextTick(() => {
            this.map = this.$refs.articleMap.mapObject;
            
            if (this.waypoints) {
                // Get all segments waypoints to one array
                let dummyWaypoints = [];

                this.waypoints.forEach(segment => {
                    dummyWaypoints = dummyWaypoints.concat(segment);
                });

                // Create a dummy polyline and fit map to it's bounds
                var dummyPolyline = L.polyline(dummyWaypoints);
                this.map.fitBounds(dummyPolyline.getBounds());
            }
        });
    },
    methods: {
        
    }
}

</script>

<style scoped>


</style>
